<template>
  <v-container fluid>
    <v-container fluid>
      <!-- <v-card class="pa-3"> -->
        <!-- First Row: Center-aligned text -->
        <v-row align="center">
          <!-- Left-aligned button -->
          <v-col cols="3" class="text-left">
            <v-btn color="primary"  @click="goToStockHome">Back</v-btn>
          </v-col>

          <!-- Center-aligned text -->
          

          <!-- Spacer to fill the right side -->
          <v-col cols="3"></v-col>
        </v-row>
      <!-- </v-card> -->
    </v-container>
    <v-card v-for="item in items" :key="item.id" class="pa-3">
      <!-- First Row: Center-aligned text -->
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h5>Parchment Outturn: {{item.parchment_OUTTURN_NUMBER}}</h5>
        </v-col>
      </v-row>

      <v-row class="no-gutters" style="margin-top: 20px">
        <v-col cols="4" class="text-left">
          <p>Miller Name: {{item.miller_NAME}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Parchment Bulk Weight: {{item.weight}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Parchment Grade: {{item.patchment_grade}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Miller Code: {{item.miller_CODE}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Grower Parchment Weight: {{item.weight}}</p>
        </v-col>
<!--        <v-col cols="4" class="text-right">
          <p>DSS Settlement Account Name: Chave Sity</p>
        </v-col>-->
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Grower Outturn: {{item.grower_OUTTURN_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Parchment Weight % : {{item.weight}}</p>
        </v-col>
<!--        <v-col cols="4" class="text-right">
          <p>DSS Settlement Account Name: Chave Sity</p>
        </v-col>-->
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h5>Clean Coffee Outturn: {{item.parchment_OUTTURN_NUMBER}}</h5>
        </v-col>
      </v-row>

      <v-row class="no-gutters" style="margin-top: 20px">
        <v-col cols="4" class="text-left">
          <p>Parchment Outturn: {{item.parchment_OUTTURN_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Clean Coffee Bulk Weight: {{item.weight}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Clean Coffee Weight: {{item.clean_coffee_weight}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Clean Coffee Weight %: {{item.miller_CODE}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Grower Clean Weight: {{item.clean_coffee_weight}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Clean Grade: {{item.clean_grade}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Grower Outturn: {{item.grower_OUTTURN_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Parchment Weight % : {{item.weight}}</p>
        </v-col>
        <!--        <v-col cols="4" class="text-right">
                  <p>DSS Settlement Account Name: Chave Sity</p>
                </v-col>-->
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h5>GRN Coffee Details: {{item.parchment_OUTTURN_NUMBER}}</h5>
        </v-col>
      </v-row>

      <v-row class="no-gutters" style="margin-top: 20px">
        <v-col cols="4" class="text-left">
          <p> Warehouse Name: {{item.warehouse_name}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Split: {{item.split_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Split</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Warehouse Location: {{item.warehouse_location}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Warrant Number: {{item.warrant_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Warrant Number: {{item.warrant_NUMBER}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Delivery Date: {{item.delivery_date}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Split Weight: {{item.split_weight}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Split Weight: {{item.split_weight}}</p>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h5>Broker Bulking/Splitting: {{item.parchment_OUTTURN_NUMBER}}</h5>
        </v-col>
      </v-row>

      <v-row class="no-gutters" style="margin-top: 20px">
        <v-col cols="4" class="text-left">
          <p> Broker Name: {{item.broker_name}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Lot Number: {{item.lot_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Clean Coffee Percentage</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Broker Code: {{item.broker_code}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Total Lot Weight: {{item.lot_weight}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Reserve Price: {{item.reserve_PRICE}}</p>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <h5>Auction Result Details: {{item.parchment_OUTTURN_NUMBER}}</h5>
        </v-col>
      </v-row>

      <v-row class="no-gutters" style="margin-top: 20px">
        <v-col cols="4" class="text-left">
          <p> Auction Result ID: {{item.auction_results_id}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Total Weight Bought: {{item.weight_BOUGHT}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Invoice Number: {{item.invoice_NUMBER}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Buyer Name: {{item.buyer_name}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Buying Price: {{item.price}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Sale Number: {{item.sale_NUMBER}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Buyer Code: {{item.buyer_code}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>ESLIP Number: {{item.eslip_NUMBER}}</p>
        </v-col>
        <v-col cols="4" class="text-right">
          <p>Sale Date: {{item.split_weight}}</p>
        </v-col>
      </v-row>
      <v-row class="mt-0 mb-0 no-gutters">
        <v-col cols="4" class="text-left">
          <p>Season: {{item.season}}</p>
        </v-col>
        <v-col cols="4" class="text-center">
          <p>Status: {{item.split_weight}}</p>
        </v-col>
      </v-row>

    </v-card>
  </v-container>
  </template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import * as XLSX from 'xlsx';
export default {
	name: 'catalogue_details',
	data: function () {
		return {
			items: [],
			message: '',
			loading: false,
			snackbar: false,
			snackbarColor: '',
			messsage: '',
			paginatedItems: [],
			permissions: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			outturn: 0,
			dialog: false,
			editedIndex: -1,
			defaultItem: {
				id: '',
				lotNumber: '',
				marks: '',
				grade: '',
				numberOfBags: '',
				numberOfPocket: '',
				weight: '',
				saleNumber: '',
				season: '',
				cert: '',
				agentCode: '',
				remark: '',
				reservePrice: '',
				deleteFlag: false,
				outTurn: ''
			},
			editedItem: {
				id: '',
				lotNumber: '',
				marks: '',
				grade: '',
				numberOfBags: '',
				numberOfPocket: '',
				weight: '',
				saleNumber: '',
				season: '',
				cert: '',
				agentCode: '',
				remark: '',
				reservePrice: '',
				actionComment: '',
				deleteFlag: false,
				outTurn: ''
			},
			lotNumberRules: [
				v => !!v || 'lotNumber is required'
			],
			gradeRules: [
				v => !!v || 'Grade is required'
			],
			outTurnRules: [
				v => !!v || 'Grade is required'
			],
			seasonRules: [
				v => !!v || 'Season is required'
			],
			saleNumberRules: [
				v => !!v || 'saleNumber  is required'
			],
			actionCommentRules: [
				v => !!v || 'Comment  is required'
			]
		}
	},
	watch: {
	},
	mounted () {
		this.getStockDetails()
		this.id = this.$route.params.id
		this.permissions = store.state.user.roleId.permissions
	},
	computed: {
		hasIdData () {
			// Assuming item.status is the property containing status data
			return this.paginatedItems.some(item => item.id !== null && item.id !== undefined)
		},
		canUploadCatalogue: function () {
			return this.hasPerm('CAN_UPLOAD_CATALOGUE')
		},
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		}
	},
	methods: {
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
    goToStockHome() {
      this.$router.push('/grower/stock2/');
    },
    exportExcel() {
      // Define worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(this.eslips, 
	//   {
    //     header: Object.keys(this.headers)
    //   }
	);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      // Export workbook to file
      XLSX.writeFile(wb, this.accountNumber+'_'+this.accountName+'_Statement.xlsx');
    },
		canBeApproved (item) {
			return item.status.id === 3
		},
		getStockDetails () {
			const url = config.serverURI + '/growerstatus/stockDetails/' + this.$route.params.id
			console.log(url)
			axios.get(url)
				.then(response => {
					// Assign the response data to `items`
					this.items = response.data

					// Optional: Log each item for debugging
					this.items.forEach(item => {
						console.log('response item == ', item)
					})
				})
				.catch(error => {
					console.log('error', error.response)
				})
			return this.items
		},
		update () {
			if (this.$refs.form.validate()) {
				var url = config.serverURI + '/upload/catalogue/update'
				console.log(this.editedItem)
				axios.post(url, this.editedItem)
					.then(response => {
						this.message = response.data.message
						if (response.data.error) {
							this.snackbarColor = 'error'
						} else {
							this.snackbarColor = 'primary'
							this.getStockDetails()
						}
						this.snackbar = true
						this.close()
					})
					.catch(error => {
						// Request failed.
						console.log('error', error.response)
						this.snackbarColor = 'error'
						this.snackbar = true
					})
			}
		},
		approveCatalogue (item) {
			var url = config.serverURI + '/upload/catalogue/approve-catalogue-item'
			console.log(item)
			axios.post(url, item)
				.then(response => {
					this.message = response.data.message
					if (response.data.error) {
						this.snackbarColor = 'error'
					} else {
						this.snackbarColor = 'primary'
						this.getStockDetails()
					}
					this.snackbar = true
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.snackbarColor = 'error'
					this.snackbar = true
				})
		}
	}
}

</script>
  <style>
  .catalogued_box_empty {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }
  .catalogued_box {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }
  .catalogued_box:after, .catalogued_box:before {
    right: 100%;
    top: 23%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .catalogued_box:after {
    border-color: rgba(255, 255, 255, 0);
    border-right-color: #fff;
    border-width: 20px;
    margin-top: -20px;
  }
  .catalogued_box:before {
    border-color: rgba(112, 112, 112, 0);
    border-right-color: #707070;
    border-width: 21px;
    margin-top: -21px;
  }
  </style>
